import { useIntl } from "react-intl"
const useLinkLanguage = () => {
  const intl = useIntl()
  switch (intl.locale) {
    case "en":
      return "en"
    case "zh-CN":
      return "sc"
    case "zh-HK":
      return "tc"
    default:
      return "tc"
  }
}

export default useLinkLanguage
